import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ProjectDocument} from '../../../core/models/project-document.interface';
import {InstallLocation} from '../../../core/models/install-location.interface';
import {MatDialog} from '@angular/material/dialog';
import {SnackbarActionEnum} from '../../../core/enums/snackbar-action.enum';
import {MatSnackBar} from '@angular/material/snack-bar';
import {InstallerService} from '../../../core/services/installer.service';
import {ConfirmationDialogComponent} from '../confirmation-dialog/confirmation-dialog.component';

@Component({
	selector: 'app-project-file-upload',
	templateUrl: './project-file-upload.component.html',
	styleUrls: ['./project-file-upload.component.scss']
})
export class ProjectFileUploadComponent implements OnInit, OnChanges, AfterViewInit {
	@Input() projectId: number;
	@Input() type: InstallLocation;
	@Input() departmentId: string;
	@Input() uploadedFiles: ProjectDocument[] | undefined;
	@Input() fileChanges: ProjectDocument[] = [];
	@Input() maxFileLength: number;
	@Input() subType: string;
	@Input() installerId: number;
	@Output('fileAddEmitter') fileAddEmitter = new EventEmitter<File[]>();
	@Output('fileRemoveEmitter') fileRemoveEmitter = new EventEmitter<File>();
	@Output('documentDtoEmitter') documentDtoEmitter = new EventEmitter<ProjectDocument[]>();
	@Output('installRemoveProjectDocumentEmitter') installRemoveProjectDocumentEmitter = new EventEmitter<ProjectDocument>();
	@Output('installRemoveDocumentEmitter') installRemoveDocumentEmitter = new EventEmitter<number>();
	files: File[] = [];
	projectDocumentDtos: ProjectDocument[] = [];

	constructor(
		private installerService: InstallerService,
		private dialog: MatDialog,
		private snackbar: MatSnackBar,
	) {}
	ngOnInit() {}
	ngAfterViewInit() {
		if (this.subType !== 'install' && this.subType !== 'installer' && this.maxFileLength == 1) {
			this.uploadedFiles = this.uploadedFiles ? this.uploadedFiles.filter((file) => file.subType == 'Survey') : this.uploadedFiles;
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.subType !== 'install' && this.subType !== 'installer' && this.uploadedFiles) {
			this.uploadedFiles = this.uploadedFiles.filter((each: ProjectDocument) => {
				return each.installLocationId === this.type.id;
			});
		}
		if (this.fileChanges.length) {
			this.files = this.files.filter((each: File, i: number) => {
				let fileMatch = this.fileChanges.find((doc) => {
					return doc.documentName === each.name;
				});
				return !fileMatch;
			});
		}
	}

	get title(): string {
		let type: string = this.type ? this.type.name : this.subType;
		switch (type) {
			case 'install':
				return 'Bid Documents';
			case 'installer':
				return 'Compliance Document';
			default:
				return 'Choose a Location...';
		}
	}

	//this any type is here because this is a custom event and the docs provide no actual type for it.
	onFilesAdded(event: any) {
		let fileNameLengthExceeded: boolean = false;
		event.addedFiles.forEach((file: File) => {
			if (file.name.length > 100) {
				fileNameLengthExceeded = true;
			}
		});

		if (fileNameLengthExceeded) {
			this.snackbar.open('Length of file name cannot exceed 100 characters, including extension.', SnackbarActionEnum.ERROR, {
				duration: 4800
			});
			return;
		}

		if (this.subType !== 'install' && this.subType !== 'installer' && !this.type) {
			this.dialog.open(ConfirmationDialogComponent, {
				data: {
					title: 'Cannot Upload File',
					message: "Please choose a location in the 'Project Details' before uploading files!"
				}
			});
			return;
		}
		const fileArray: File[] = [];
		fileArray.push(...event.addedFiles);
		fileArray.forEach((each: File, i: number): void => {
			if (!this.files.find((file) => file.name == each.name)) {
				this.files.push(fileArray[i]);
				this.projectDocumentDtos.push({
					documentName: fileArray[i].name,
					type: fileArray[i].type,
					subType: this.subType ? this.subType : '',
					version: '',
					installLocationId: this.type ? this.type.id : 0,
					workflowStatusId: this.departmentId ? +this.departmentId : 0,
					documentHash: '',
					versionSeq: 1,
					archived: false,
					projectId: this.projectId ? +this.projectId : 0,
					userId: 0
				});
			} else {
				const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
					data: {
						title: 'Cannot Upload File',
						message: 'This file has already been added!'
					}
				});
			}
		});

		this.fileAddEmitter.emit(fileArray);
		this.documentDtoEmitter.emit(this.projectDocumentDtos);
	}

	onRemove(file: File) {
		if (this.maxFileLength == 1) {
			if (this.subType === 'installer') {
				this.fileRemoveEmitter.emit(file);
			}
			this.projectDocumentDtos = [];
			this.uploadedFiles = [];
		} else {
			this.fileRemoveEmitter.emit(file);
		}
		this.files.splice(this.files.indexOf(file), 1);
	}

	downloadFile(event: Event, fileName: string) {
		event.stopPropagation();
		if (this.subType === 'install') {
			// this.installBidService.findAttachment(fileName).subscribe((response) => {
			//   this.fileDownload(response, fileName);
			// });
		} else if (this.subType === 'installer') {
			this.installerService.findAttachment(this.installerId, fileName).subscribe((response) => {
				this.fileDownload(response, fileName);
			});
		}
	}

	fileDownload(response: string, fileName: string) {
		//window.open() was opening then closing the tab, this way just simply downloads the file.
		const a = document.createElement('a');
		a.style.display = 'none';
		a.href = response;
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		window.URL.revokeObjectURL(a.href);
		document.body.removeChild(a);
	}

	stopPropagation(event: Event) {
		event.stopPropagation();
	}
}
